export default __webpack_public_path__ + "static/media/general-surgery.14031bab.jpg";